<div class="points-summary-bar d-flex justify-content-between d-lg-none">
  <!-- Back Button -->
  <div class="text-white cursor-pointer d-flex align-items-center d-lg-none bg-glass-dark back-btn" (click)="location.back()">
    <span class="material-icons icons"> arrow_back_ios_new </span>
  </div>
  <!-- Points Bar -->
  <div class="justify-content-center point-container bg-glass-dark">
    <fgb-points-summary></fgb-points-summary>
  </div>
</div>
